import { Button, TextField } from "@mui/material";
import { Component } from "react";
import { Navigate } from "react-router";
import axios from "axios";

export default class LoginPage extends Component
{
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            redirect: false
        };

        this.handleChangeEMail = this.handleChangeEMail.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleSubmit=this.handleSubmit.bind(this);
    }

    handleChangeEMail(event) {
        this.setState({email: event.target.value});
    }

    handleChangePassword(event) {
        this.setState({password: event.target.value});
    }

    handleSubmit() {
        console.log('LOGIN',this.state.email);
        let data = new URLSearchParams();
        data.append("username", this.state.email);
        data.append("password", this.state.password);

        let config = {
        method: 'post',
        url: '/perform_login',
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-XSRF-TOKEN': '$1'
        },
        data : data
        };

        axios.request(config)
        .then((response) => {
            this.setState({redirect: true});
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log("errorr" + error);
        });
    }

    render() {
        return(
            <div className="centered">
                <h1 className="centered">Earlydeskbird</h1>
                <h2 className="centered" style={{color:"red"}}>Dieser Service wird zum<br/>01.03.26 eingestellt.</h2>
                <img src="grafik.png" alt="logo of earlydeskbird"/>
                <TextField label="email" onChange={this.handleChangeEMail}></TextField>
                <TextField label="password" type="password" onChange={this.handleChangePassword}></TextField>
                <Button onClick={this.handleSubmit}>LOGIN</Button>
                {!!this.state.redirect && <Navigate replace to="/" />}
            </div>
        );
    }
}